interface DollarSignSVGProps {
  style: React.CSSProperties;
  color: string;
}

const DollarSignSVG = ({ color, style }: DollarSignSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="50"
    viewBox="0 0 48 50"
    fill="none"
  >
    <g clipPath="url(#clip0_535_18852)">
      <path
        d="M40.6243 1.04102H7.29102C3.83268 1.04102 1.04102 3.83268 1.04102 7.29102V48.9577L5.20768 44.791L9.37435 48.9577L13.541 44.791L17.6243 48.9577L21.8743 44.791L26.041 48.9577L30.2077 44.791L34.3743 48.9577V7.29102"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.8745 7.29102V11.4577H34.3745V7.29102C34.3745 5.43685 35.1662 3.77018 36.4578 2.64518C37.562 1.64518 39.0203 1.04102 40.6245 1.04102C44.0828 1.04102 46.8745 3.83268 46.8745 7.29102Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.541 30.2075C13.541 30.2075 13.541 34.3742 19.3952 34.3742C26.7285 34.3742 26.7285 24.395 19.3952 22.9159C12.0618 21.4367 12.0618 11.4575 19.3952 11.4575C23.9577 11.4575 23.9577 15.6242 23.9577 15.6242"
        stroke={color}
        strokeWidth="2.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.791 7.29102V11.4577"
        stroke={color}
        strokeWidth="2.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.791 34.3745V38.5412"
        stroke={color}
        strokeWidth="2.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_535_18852">
        <rect width="47.9167" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default DollarSignSVG;
